import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export interface WalletData {
  id: string;
  user_id: string;
  balance_etb: number;
  currency: string;
  low_balance_threshold: number;
}

export function useWallet() {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ['wallet', user?.id],
    enabled: !!user,
    queryFn: async (): Promise<WalletData | null> => {
      const { data } = await supabase
        .from('wallets' as any)
        .select('id, user_id, balance_etb, currency, low_balance_threshold')
        .eq('user_id', user!.id)
        .maybeSingle();
      return (data as any) || {
        id: '', user_id: user!.id, balance_etb: 0, currency: 'ETB', low_balance_threshold: 1000,
      };
    },
  });
  return {
    ...query,
    balance: Number(query.data?.balance_etb || 0),
    threshold: Number(query.data?.low_balance_threshold || 1000),
    lowBalance: Number(query.data?.balance_etb || 0) < Number(query.data?.low_balance_threshold || 1000),
  };
}
